export const variables = {
  APP_COLOR: '#EF4F2F',
  APP_COLOR_DARK: '#7C221E'
};
